import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../features/auth';
import { useModal } from '../features/modal/ModalContext';
import { FaStripe, FaInstagram, FaTiktok } from 'react-icons/fa';
import { GrAmex } from 'react-icons/gr';
import { SiVisa, SiMastercard } from 'react-icons/si';

const MobileFooter = () => {
  const location = useLocation();
  const { user } = useAuth();
  const { isMachineModalOpen } = useModal();
  const isTutorialRoute = location.pathname === '/tutorial';
  const hideFooter = isTutorialRoute || user || isMachineModalOpen;

  const [supportExpanded, setSupportExpanded] = useState(false);

  // CHANGED: Close support menu when route changes
  useEffect(() => {
    setSupportExpanded(false);
  }, [location.pathname]);

  // CHANGED: Hide footer when user is logged in
  if (hideFooter) {
    return null;
  }

  return (
    <footer className="mobile-footer border-t border-white/40 bg-white/80 py-4 backdrop-blur-xl">
      <div className="mx-auto w-full max-w-6xl px-4">
        <div className="flex flex-col gap-3">
          <div className="flex items-center justify-between">
            <p className="text-xs text-ponpon-navy/60">© {new Date().getFullYear()} PonPon!</p>
            <button
              type="button"
              onClick={() => setSupportExpanded((prev) => !prev)}
              className="flex items-center gap-1.5 text-xs font-semibold text-ponpon-navy/70 transition hover:text-ponpon-coral"
              aria-expanded={supportExpanded}
            >
              <span>Support & Info</span>
              <span className="text-base leading-none">{supportExpanded ? '−' : '+'}</span>
            </button>
          </div>
          {supportExpanded ? (
            <>
              <nav className="flex flex-col gap-2 pt-2 border-t border-white/20">
                <Link
                  to="/about"
                  className="text-xs font-medium text-ponpon-navy/70 transition hover:text-ponpon-coral"
                >
                  About
                </Link>
                <Link
                  to="/faq"
                  className="text-xs font-medium text-ponpon-navy/70 transition hover:text-ponpon-coral"
                >
                  FAQ
                </Link>
                <Link
                  to="/online-gachapon"
                  className="text-xs font-medium text-ponpon-navy/70 transition hover:text-ponpon-coral"
                >
                  What Is Online Gachapon?
                </Link>
                <Link
                  to="/terms"
                  className="text-xs font-medium text-ponpon-navy/70 transition hover:text-ponpon-coral"
                >
                  Terms of Service
                </Link>
                <Link
                  to="/privacy"
                  className="text-xs font-medium text-ponpon-navy/70 transition hover:text-ponpon-coral"
                >
                  Privacy Policy
                </Link>
                <Link
                  to="/return-refund"
                  className="text-xs font-medium text-ponpon-navy/70 transition hover:text-ponpon-coral"
                >
                  Return & Refund
                </Link>
              </nav>
              {/* CHANGED: Add social media icons section */}
              <div className="flex items-center justify-center border-t border-white/20 pt-3">
                <div className="flex items-center gap-2 text-ponpon-navy/50">
                  <a
                    href="https://www.instagram.com/ponpon.app/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="transition hover:text-ponpon-navy"
                    aria-label="Instagram"
                  >
                    <FaInstagram className="h-6 w-6" />
                  </a>
                  <a
                    href="https://www.tiktok.com/@ponpon.app"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="transition hover:text-ponpon-navy"
                    aria-label="TikTok"
                  >
                    <FaTiktok className="h-6 w-6" />
                  </a>
                </div>
              </div>
              {/* CHANGED: Add payment logos section inside dropdown */}
              <div className="flex items-center justify-center border-t border-white/20 pt-3">
                <div className="flex items-center gap-2 text-ponpon-navy/50">
                  <FaStripe className="h-5 w-auto" aria-label="Stripe" />
                  <SiVisa className="h-5 w-auto" aria-label="Visa" />
                  <SiMastercard className="h-5 w-auto" aria-label="Mastercard" />
                  <GrAmex className="h-5 w-auto" aria-label="American Express" />
                </div>
              </div>
            </>
          ) : null}
        </div>
      </div>
    </footer>
  );
};

export default MobileFooter;

